/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 */

import View from "App/view/view";
import Camera from "App/view/cameras/camera";
import {CameraTypeEnum} from "js_interface/src/modules/view_controls/scene_view_controls_enums";

/**
 *  Camera for Stereo view mode.
 */
export default
class CameraVR extends Camera {

    protected leftFrustum: any = {};
    protected rightFrustum: any = {};

    protected _renderingLeftView: boolean = false;
    protected _renderingRightView: boolean = false;

    constructor(aView: View) {
        super(aView);
    }

    public setRenderingLeftView() {
        this._renderingLeftView = true;
        this._renderingRightView = false;
    }

    public setRenderingRightView() {
        this._renderingLeftView = false;
        this._renderingRightView = true;
    }

    public getCameraType(): CameraTypeEnum {
        return CameraTypeEnum.WEBVR;
    }
}
